const keys = [
  {
    keys: ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
    className: "keyboard--top--row",
  },
  {
    keys: ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
    className: "keyboard--mid--row",
  },
  {
    keys: ["z", "x", "c", "v", "b", "n", "m", ",", "."],
    className: "keyboard--bot--row",
  },
  {
    keys: ["spacebar"],
    className: "spacebar--row",
  },
];

export default keys;
